import React from 'react';
import OnboardingPageOverlay from '../../shared/OnboardingPageOverlay';
import ProductCatalogOnboardingStep from './ProductCatalogOnboardingStep';

const ProductCatalogOnboardingOverlay: React.FC = () => (
  <OnboardingPageOverlay stepId="products">
    {(onDismiss) => <ProductCatalogOnboardingStep onDismiss={onDismiss} />}
  </OnboardingPageOverlay>
);

export default ProductCatalogOnboardingOverlay;
